<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span v-if="actionType === 'EDIT'">Edit OLT</span>
              <span v-else>Adding OLT</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="OLT Name*"
                      v-model="form.oltName"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="OLT IP*"
                      v-model="form.oltIp"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Version*"
                      v-model="form.version"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    class="mt-0 pt-0"
                    v-if="actionType === 'ADD'"
                  >
                    <v-text-field
                      label="Location*"
                      v-model="form.location"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    class="mt-0 pt-0"
                    v-if="actionType === 'ADD'"
                  >
                    <v-select
                      :items="types"
                      label="Type*"
                      :rules="rules.required"
                      v-model="form.type"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="VLan*"
                      v-model="form.vlan"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Bras Mac Address*"
                      v-model="form.macAddress"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="config"
                      label="Config*"
                      :rules="rules.required"
                      v-model="form.config"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Username*"
                      v-model="form.username"
                      :rules="actionType === 'ADD' ? rules.required : []"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Password*"
                      v-model="form.password"
                      :rules="actionType === 'ADD' ? rules.required : []"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click="closeDialog()">
                Close
              </v-btn>
              <v-btn
                v-if="actionType === 'EDIT'"
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onUpdate()"
                class="px-10"
              >
                Update
              </v-btn>

              <v-btn
                v-else
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- <Snackbars :isShow="isShow" :testDisplay="textDisplay"></Snackbars> -->
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
// import Snackbars from "./Snackbars.vue";
export default {
  name: "EditOltDialog",
  components: {
    // Snackbars
  },
  data() {
    return {
      config: [1, 2],
      types: ["HUAWEI", "NOKIA", "ZTE"],
      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        oltName: "",
        oltIp: "",
        version: "",
        type: "",
        vlan: "",
        location: "",
        config: "",
        username: "",
        password: "",
      },
    };
  },

  props: ["dialog", "data", "actionType"],

  methods: {
    async onUpdate() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      let data = this.form;
      data._id = this.$props.data._id;

      await this.$api
        .put("olt-list", data)
        .then((response) => {
          const res = response.data;

          this.loadingBtn = false;
          this.$refs.form.reset();

          if (!res.status) {
            this.$emit("response", {
              status: false,
              message: res.message,
            });
            return;
          }

          this.$emit("response", {
            status: true,
            message: "OLT is successfully updated.",
          });
        })
        .catch((e) => {
          this.$emit("response", {
            status: false,
            message: e,
          });
          this.loadingBtn = false;
        });
    },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      await this.$api
        .post("/olt-list", this.form)
        .then((response) => {
          // console.log(response)
          const res = response.data;
          this.loadingBtn = false;
          this.$refs.form.reset();

          if (!res.status) {
            this.$emit("response", {
              status: false,
              message: res.message,
            });
            return;
          }

          this.$emit("response", {
            status: true,
            message: "OLT is successfully saved.",
          });
        })
        .catch((e) => {
          this.$emit("response", {
            status: false,
            message: e,
          });
          this.loadingBtn = false;
        });
    },

    closeDialog() {
      this.$refs.form.reset();
      this.$emit("close", true);
    },

    // formatDate(d) {
    //   return moment(d).format("YYYY-MM-DD HH:mm:ss");
    // },
  },
  computed: {
    // startDateDisp() {
    //   return this.form.promo_startdate;
    //   // format/do something with date
    // },
    // endDateDisp() {
    //   return this.form.promo_enddate;
    //   // format/do something with date
    // },
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },

  watch: {
    dialog() {
      if (this.$props.actionType === "EDIT") {
        setTimeout(() => {
          const currentData = this.$props.data;
          const form = this.form;

          Object.keys(form)
            .filter((key) => key in currentData)
            .forEach((key) => {
              form[key] = currentData[key];
            });
        }, 500);
      } else {
        const form = this.form;

        Object.keys(form).forEach((key) => {
          form[key] = "";
        });
      }
    },
  },
};
</script>
